import GuestRegisterButton from './GuestRegisterButton'

export default GuestRegisterButton
